"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftCreateDto = instanceOfShiftCreateDto;
exports.ShiftCreateDtoFromJSON = ShiftCreateDtoFromJSON;
exports.ShiftCreateDtoFromJSONTyped = ShiftCreateDtoFromJSONTyped;
exports.ShiftCreateDtoToJSON = ShiftCreateDtoToJSON;
exports.ShiftCreateDtoToJSONTyped = ShiftCreateDtoToJSONTyped;
const OnCallShiftCreateDto_1 = require("./OnCallShiftCreateDto");
const DirectRequestFallback_1 = require("./DirectRequestFallback");
const StipendCreateDto_1 = require("./StipendCreateDto");
const ShiftType_1 = require("./ShiftType");
const ShiftTime_1 = require("./ShiftTime");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the ShiftCreateDto interface.
 */
function instanceOfShiftCreateDto(value) {
    if (!('shiftTime' in value) || value['shiftTime'] === undefined)
        return false;
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    return true;
}
function ShiftCreateDtoFromJSON(json) {
    return ShiftCreateDtoFromJSONTyped(json, false);
}
function ShiftCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftTime': (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'shiftType': (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'totalRate': json['totalRate'],
        'description': json['description'] == null ? undefined : json['description'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'facilityId': json['facilityId'],
        'startDate': (new Date(json['startDate'])),
        'customStartTime': json['customStartTime'] == null ? undefined : json['customStartTime'],
        'customEndTime': json['customEndTime'] == null ? undefined : json['customEndTime'],
        'specialtyCode': json['specialtyCode'],
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
        'onCallShift': json['onCallShift'] == null ? undefined : (0, OnCallShiftCreateDto_1.OnCallShiftCreateDtoFromJSON)(json['onCallShift']),
        'directRequestNurseId': json['directRequestNurseId'] == null ? undefined : json['directRequestNurseId'],
        'directRequestFallback': json['directRequestFallback'] == null ? undefined : (0, DirectRequestFallback_1.DirectRequestFallbackFromJSON)(json['directRequestFallback']),
    };
}
function ShiftCreateDtoToJSON(json) {
    return ShiftCreateDtoToJSONTyped(json, false);
}
function ShiftCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'totalRate': value['totalRate'],
        'description': value['description'],
        'isSearchable': value['isSearchable'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'facilityId': value['facilityId'],
        'startDate': ((value['startDate']).toISOString().substring(0, 10)),
        'customStartTime': value['customStartTime'],
        'customEndTime': value['customEndTime'],
        'specialtyCode': value['specialtyCode'],
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
        'onCallShift': (0, OnCallShiftCreateDto_1.OnCallShiftCreateDtoToJSON)(value['onCallShift']),
        'directRequestNurseId': value['directRequestNurseId'],
        'directRequestFallback': (0, DirectRequestFallback_1.DirectRequestFallbackToJSON)(value['directRequestFallback']),
    };
}
//# sourceMappingURL=ShiftCreateDto.js.map